// Central route map so Nav/Footer links and <Route> paths never drift apart.
export const PATHS = {
  home: '/',
  privacy: '/privacy',
  legalDisclosures: '/legal-disclosures',
  ccpp: '/ccpp',
  security: '/security',
  terms: '/terms',
  dataPartners: '/data-partners',
  optOut: '/opt-out',
  businessProfiles: '/business-profiles',
};

export const LEGAL_LINKS = [
  { label: 'Privacy Policy', path: PATHS.privacy },
  { label: 'Legal Disclosures', path: PATHS.legalDisclosures },
  { label: 'CCPP', path: PATHS.ccpp },
  { label: 'Security Statement', path: PATHS.security },
  { label: 'Terms of Use', path: PATHS.terms },
  { label: 'Data Partners', path: PATHS.dataPartners },
  { label: 'Opt-Out', path: PATHS.optOut },
  { label: 'Business Profiles', path: PATHS.businessProfiles },
];
